import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrong-sms-dialog" }
const _hoisted_2 = { class: "v-card-wrapper" }
const _hoisted_3 = { class: "v-sheet v-card" }
const _hoisted_4 = { class: "v-card__title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "v-card__text" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "wrong-sms-dialog__contact" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "wrong-sms-dialog__contact" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "after" }
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            innerHTML: _ctx.$t('title')
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "wrong-sms-dialog__content",
            innerHTML: _ctx.$t('text')
          }, null, 8, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: require('@project/public/img/wrong-bonus/whatsapp.png'),
              alt: ""
            }, null, 8, _hoisted_9),
            _cache[0] || (_cache[0] = _createTextVNode(" +7 964 568 01 03 "))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: require('@project/public/img/wrong-bonus/phone.png'),
              alt: ""
            }, null, 8, _hoisted_11),
            _cache[1] || (_cache[1] = _createTextVNode(" 8 800 200 80 88 "))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.$projectName === _ctx.$projectNames.MTI)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "wrong-sms-dialog__decor" }, [
              _createElementVNode("div", { class: "wrong-sms-dialog__decor-wrap" }, [
                _createElementVNode("span")
              ]),
              _createElementVNode("div", { class: "wrong-sms-dialog__decor-wrap" }, [
                _createElementVNode("span")
              ]),
              _createElementVNode("div", { class: "wrong-sms-dialog__decor-wrap" }, [
                _createElementVNode("span")
              ])
            ], -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}